module.exports = __webpack_public_path__ + "resources/activity-09c1dd70466850c53775d5615e68927b.svg";